<template>
    <el-scrollbar class="data-center">
        <div class="data-content">
            <div class="filter-box" :class="isSchoolData ? 'is-school-data' : ''">
                <div class="filter-item">
                    <div class="icon-box">
                        <i class="iconfont">&#xe60f;</i>
                    </div>
                    <span class="item-name">{{school_name}}</span>
                </div>
                <div class="filter-item">
                    <div class="icon-box">
                        <i class="iconfont">&#xe69f;</i>
                    </div>
                    <span class="item-name">班级</span>
                </div>
                <el-select v-model="selectValue" placeholder="请选择" class="data-select" @change="selectedClass">
                    <el-option
                            v-for="item in classList"
                            :key="item.class_id"
                            :label="item.class_name"
                            :value="item.class_id">
                    </el-option>
                </el-select>
            </div>
            <div class="data-item">
                <div class="title">
                    <i class="iconfont">&#xe62f;</i>
                    <span class="text">1+X电子商务客户服务</span>
                </div>
                <div class="data-body">
                    <div class="box">
                        <div class="box-item">
                            <div class="charts-top">
                                <div class="left-box">
                                    <span class="left-title">电子商务客服考试</span>
                                </div>
                            </div>
                            <div class="top-exam" id="topExam" style="width: 100%;height:450px;"></div>
                        </div>
                        <div class="box-item" style="display: flex;flex-direction: column;">
                            <div class="charts-top">
                                <div class="left-box">
                                    <span class="left-title">考试合格率</span>
                                </div>
                            </div>
                            <div class="charts-box">
                                <div class="pass-rate">合格率</div>
                                <el-progress type="circle" :percentage="second_data.pass_rate" color="#2C95FF" :width="264"
                                             :stroke-width="10"></el-progress>
                            </div>
                        </div>
                        <div class="box-item">
                            <div class="charts-top">
                                <div class="left-box">
                                    <span class="left-title">技能分析</span>
                                </div>
                                <div class="right-box">
                                    <el-select v-model="selectValue1" placeholder="请选择" class="data-select" @change="selectedSkill">
                                        <el-option
                                                v-for="item in skillList"
                                                :key="item.parant_tag_id"
                                                :label="item.parant_tag_name"
                                                :value="item.parant_tag_id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="top-exam" :class="noSkillData ? 'is-no-data' : ''" id="skillAnalysis" style="width: 100%;height:450px;"></div>
                            <div v-if="skillList.length === 0" class="no-data" style="position: relative;z-index: 9;">暂无数据</div>
                        </div>
                    </div>
                    <div class="bottom-box">
                        <div class="box-item">
                            <div class="item-content">
                                <div class="top-content">
                                    <div class="top-title">模拟考次数</div>
                                    <div class="top-num">{{fourth_data.total_num}}</div>
                                </div>
                                <div class="middle-content">
                                    <div class="middle-left">
                                        <span class="first-title">月同比</span>
                                        <i class="el-icon-caret-bottom" v-if="fourth_data.ytb_arrow === 2"></i>
                                        <i class="el-icon-caret-bottom" v-else></i>
                                        <span>{{fourth_data.ytb_num}}</span>
                                    </div>
                                    <div class="middle-right">
                                        <span class="first-title">月环比</span>
                                        <i class="el-icon-caret-top"></i>
                                        <span>{{fourth_data.yhb_num}}</span>
                                    </div>
                                </div>
                                <div class="bottom-content">
                                    <span class="bottom-left">月均考试次数</span>
                                    <span class="bottom-right">{{fourth_data.ave_num}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="box-item">
                            <div class="item-content">
                                <div class="top-content">
                                    <div class="top-title">考试次数</div>
                                    <div class="top-num">{{fifth_data.total_num}}</div>
                                </div>
                                <div class="middle-content">
                                    <div class="top-exam" id="examNum" style="width: 100%;height:100%;"></div>
                                </div>
                                <div class="bottom-content">
                                    <span class="bottom-left">月均考试次数</span>
                                    <span class="bottom-right">{{fifth_data.ave_num}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="box-item">
                            <div class="item-content">
                                <div class="top-content">
                                    <div class="top-title">训练人数</div>
                                    <div class="top-num">{{sixth_data.total_num}}</div>
                                </div>
                                <div class="middle-content">
                                    <div class="top-exam" id="trainPeopleNum" style="width: 100%;height:100%;"></div>
                                </div>
                                <div class="bottom-content">
                                    <span class="bottom-left">日均训练人数</span>
                                    <span class="bottom-right">{{sixth_data.ave_num}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="box-item">
                            <div class="item-content">
                                <div class="top-content">
                                    <div class="top-title">训练次数</div>
                                    <div class="top-num">{{seventh_data.total_num}}</div>
                                </div>
                                <div class="middle-content">
                                    <div class="top-exam" id="trainNum" style="width: 100%;height:100%;"></div>
                                </div>
                                <div class="bottom-content">
                                    <span class="bottom-left">日均训练次数</span>
                                    <span class="bottom-right">{{seventh_data.ave_num}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="data-item mock-exam-item">
                <div class="title">
                    <i class="iconfont">&#xe6b7;</i>
                    <span class="text">模拟考试</span>
                </div>
                <div class="data-body">
                    <div class="box">
                        <div class="left">
                            <div class="exam-num">
                                <div class="icon">
                                    <i class="iconfont">&#xe62a;</i>
                                </div>
                                <div class="num-show">
                                    <span class="text">考试人数：</span>
                                    <span class="num">{{mocks_data.exam_num}}</span>
                                </div>
                            </div>
                            <div class="certified-num">
                                <div class="icon">
                                    <i class="iconfont">&#xe639;</i>
                                </div>
                                <div class="num-show">
                                    <span class="text">合格人数：</span>
                                    <span class="num">{{mocks_data.pass_num}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="pass-rate">合格率</div>
                            <el-progress type="circle" :percentage="mocks_data.pass_rate" color="#2C95FF" :width="202"
                                         :stroke-width="10"></el-progress>
                        </div>
                    </div>
                </div>
                <div style="background-color: #fff;margin-top: 20px;box-shadow: 0 0 10px 0 rgba(14, 168, 94, 0.1);height: 520px;">
                    <div class="charts-top">
                        <div class="left-box">
                            <span class="left-title">模拟考试数据</span>
                            <span class="right-title">近期20场模拟考试</span>
                        </div>
                    </div>
                    <div class="mock-exam" :class="noData ? 'is-no-data' : ''" id="mockExam" style="width: 100%;height:450px;"></div>
                    <div v-if="mocks_data.list.length === 0" class="no-data" style="position: relative;z-index: 9;">暂无数据</div>
                </div>
            </div>
            <div class="data-item">
                <div class="title">
                    <i class="iconfont">&#xe70e;</i>
                    <span class="text">班级数据</span>
                </div>
                <div class="class-item" v-for="item in classData">
                    <span class="class-name">{{item.class_name}}</span>
                    <span class="class-top">TOP10</span>
                    <div class="class-table">
                        <div class="table-title">
                            <span class="title-item">学生名称</span>
                            <span class="title-item">训练次数</span>
                            <span class="title-item">模拟次数</span>
                            <span class="title-item">考试次数</span>
                            <span class="title-item">1+X电子商务客服证书</span>
                        </div>
                        <div class="table-body">
                            <div class="body-item" v-for="itemStudent in item.list">
                                <div class="student-name title-item">
                                    <img :src="itemStudent.avatar ? itemStudent.avatar : require('../../../assets/images/user_img.png')" alt="">
                                    <span class="name">{{itemStudent.nickname}}</span>
                                </div>
                                <span class="text title-item">{{itemStudent.train_num}}</span>
                                <span class="text title-item">{{itemStudent.simulate_num}}</span>
                                <span class="text title-item">{{itemStudent.official_num}}</span>
                                <i class="iconfont title-item pass-i" v-if="itemStudent.has_certificate === 1">&#xe656;</i>
                                <i class="iconfont title-item no-pass-i" v-else>&#xe659;</i>
                            </div>
                        </div>
                    </div>
                    <div class="no-data" v-if="item.list.length === 0" style="height: 30px;margin-top: 20px;">暂无数据</div>
                    <div class="more" @click="viewMore(item.class_id)" v-else>查看更多<i class="iconfont">&#xe602;</i></div>
                </div>
                <div class="no-data" v-if="classData.length === 0" style="height: 30px;margin-top: 20px;">暂无数据</div>
            </div>
        </div>
    </el-scrollbar>
</template>

<script>
    import echarts from "echarts";
    import { infocenterteacherIndexdata, infocenterschoolIndexdata } from '@/utils/apis.js'
    import { NumberToChinese } from "@/utils/common";

    export default {
        name: "Index",
        data() {
            return {
                //角色id
                role: '',
                //学校名称
                school_name: '',
                //班级列表
                classList: [],
                //电子商务客服考试模块
                first_data: {
                    exam_num: 0,//考试人数
                    certificate_num: 0 //获证人数
                },
                //考试合格率
                second_data: {
                    pass_rate: 0 //合格率
                },
                //技能分析列表
                skillList: [],
                skillRate: [],
                skill_children_list: [],
                selectValue: 0,
                selectValue1: null,
                //模拟考次数模块
                fourth_data: {
                    total_num: null,
                    ave_num: null,
                    ytb_num: '-',
                    ytb_arrow: 0,
                    yhb_num: '-',
                    yhb_arrow: 0
                },
                //考试次数模块
                fifth_data: {
                    total_num: null,
                    ave_num: null,
                    curve_data: [],
                },
                //训练人数模块
                sixth_data: {
                    total_num: null,
                    ave_num: null,
                    curve_data: []
                },
                //训练次数模块
                seventh_data: {
                    total_num: null,
                    ave_num: null,
                    curve_data: []
                },
                //模拟考试模块
                mocks_data: {
                    exam_num: 0,//考试人数
                    pass_num: 0,//合格人数
                    pass_rate: 0,//合格率
                    list: []//近期20场模拟考试数据
                },
                //班级数据
                classData: [],
                //是否是学校管理员端的数据中心
                isSchoolData: false,
                //是否有技能分析数据
                noSkillData: false,
                //是否有模拟考试数据
                noData: false,
                //图表
                topExam: null,
                skillAnalysis: null,
                examNum: null,
                trainPeopleNum: null,
                trainNum: null,
                mockExam: null,
            }
        },
        mounted() {
            this.getDataDetail();
        },
        created() {
            this.role = localStorage.getItem('role');
            if (this.role === '2') {
                this.isSchoolData = true;
            }
        },
        methods: {
            //获取数据中心详细信息
            async getDataDetail() {
                let param = {}
                if (this.selectValue) {
                    param.class_id = this.selectValue;
                } else {
                    param.class_id = 0;
                }
                let url = '';
                if (this.role === '2') {
                    url = infocenterschoolIndexdata;

                } else {
                    url = infocenterteacherIndexdata;
                }
                let res
                res = await url(param);
                this.school_name = res.data.head_data.school_name;
                this.classList = res.data.head_data.class_data;
                //电子商务客服考试模块
                this.first_data.exam_num = res.data.formal_exam_data.first_data.exam_num;
                this.first_data.certificate_num = res.data.formal_exam_data.first_data.certificate_num;
                //考试合格率
                this.second_data.pass_rate = res.data.formal_exam_data.second_data.pass_rate;
                //技能分析数据
                if (res.data.formal_exam_data.third_data.length > 0) {
                    this.skillList = res.data.formal_exam_data.third_data;
                    if (!this.selectValue1) {
                        this.selectValue1 = res.data.formal_exam_data.third_data[0].parant_tag_id;
                    }
                    this.noSkillData = false;
                } else {
                    this.noSkillData = true;
                }
                //模拟考次数模块
                this.fourth_data = {
                    total_num: res.data.formal_exam_data.fourth_data.total_num,
                    ave_num: res.data.formal_exam_data.fourth_data.ave_num,
                    ytb_num: res.data.formal_exam_data.fourth_data.ytb_num,
                    ytb_arrow: res.data.formal_exam_data.fourth_data.ytb_arrow,
                    yhb_num: res.data.formal_exam_data.fourth_data.yhb_num,
                    yhb_arrow: res.data.formal_exam_data.fourth_data.yhb_arrow
                }
                //考试次数模块
                this.fifth_data = {
                    total_num: res.data.formal_exam_data.fifth_data.total_num,
                    ave_num: res.data.formal_exam_data.fifth_data.ave_num,
                    curve_data: res.data.formal_exam_data.fifth_data.curve_data,
                }
                //训练人数模块
                this.sixth_data = {
                    total_num: res.data.formal_exam_data.sixth_data.total_num,
                    ave_num: res.data.formal_exam_data.sixth_data.ave_num,
                    curve_data: res.data.formal_exam_data.sixth_data.curve_data
                }
                //训练次数模块
                this.seventh_data = {
                    total_num: res.data.formal_exam_data.seventh_data.total_num,
                    ave_num: res.data.formal_exam_data.seventh_data.ave_num,
                    curve_data: res.data.formal_exam_data.seventh_data.curve_data
                }
                //模拟考试模块
                this.mocks_data = {
                    exam_num: res.data.mocks_data.exam_num,
                    pass_num: res.data.mocks_data.pass_num,
                    pass_rate: res.data.mocks_data.pass_rate,
                    list: res.data.mocks_data.list,
                }
                if (res.data.mocks_data.list.length > 0) {
                    this.noData = false;
                } else {
                    this.noData = true;
                }
                //班级数据
                if (res.data.buttom_data.length > 0) {
                    this.classData = res.data.buttom_data;
                } else {
                    this.classData = [];
                }
                //echarts自适应
                this.$nextTick(() => {
                    this.topExam = this.$echarts.init(document.getElementById('topExam'));
                    this.skillAnalysis = this.$echarts.init(document.getElementById('skillAnalysis'));
                    this.examNum = this.$echarts.init(document.getElementById('examNum'));
                    this.trainPeopleNum = this.$echarts.init(document.getElementById('trainPeopleNum'));
                    this.trainNum = this.$echarts.init(document.getElementById('trainNum'));
                    this.mockExam = this.$echarts.init(document.getElementById('mockExam'));

                    let resizeTimer = null;
                    window.onresize = () => {
                        clearTimeout(resizeTimer);
                        resizeTimer = setTimeout(() => {
                            this.topExam.resize();
                            this.skillAnalysis.resize();
                            this.examNum.resize();
                            this.trainPeopleNum.resize();
                            this.trainNum.resize();
                            this.mockExam.resize();
                        }, 100)
                    }
                    this.setTopExam();
                    if (this.skillList.length > 0) {
                        this.getSkillValue();
                        if (this.skill_children_list.length > 0) {
                            this.setSkillAnalysis();
                        }
                    }
                    if (this.fifth_data.curve_data) {
                        this.setExamNum();
                    }
                    if (this.sixth_data.curve_data) {
                        this.setTrainPeopleNum();
                    }
                    if (this.seventh_data.curve_data) {
                        this.setTrainNum();
                    }
                    if (this.mocks_data.list.length > 0) {
                        this.setMockExam();
                    }
                })
            },
            //获取技能分析数据
            getSkillValue() {
                if (this.skillList.length > 0) {
                    let skill_children = [];
                    let skill_children_name = {};
                    skill_children = this.skillList;
                    skill_children.forEach(item => {
                        if (item.children.length > 0) {
                            item.children.forEach(itemChildren => {
                                if (itemChildren.parant_tag_id === this.selectValue1) {
                                    this.skillRate.push(itemChildren.rate);
                                    skill_children_name = {
                                        name: itemChildren.tag_name,
                                        max: 100
                                    }
                                    this.skill_children_list.push(skill_children_name);
                                }
                            })
                        }
                    })
                    if (this.skill_children_list.length > 0) {
                        this.setSkillAnalysis();
                    }
                }
            },
            //选择班级
            selectedClass(val) {
                this.selectValue = val;
                this.skill_children_list = [];
                this.skillRate = [];
                this.skillList = [];
                this.selectValue1 = '';
                this.getDataDetail();
            },
            //选择技能分析
            selectedSkill(val) {
                this.selectValue1 = val;
                this.skill_children_list = [];
                this.skillRate = [];
                this.getSkillValue();
            },
            //电子商务客服考试
            setTopExam() {
                this.topExam.setOption(
                    {
                        tooltip: {
                            borderWidth: "1", //边框宽度设置1
                            borderColor: "#888",
                            backgroundColor: '#fff',
                            textStyle: {
                                color: "#666666" //设置文字颜色
                            },
                        },
                        grid: { //图表和父盒子之间的距离
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            top: '20%',
                            containLabel: true
                        },
                        xAxis: [
                            {
                                type: 'category',
                                splitLine: {show: false}, //去除网格线
                                axisLine: {
                                    show: false,
                                },
                                axisTick: {
                                    show: false,
                                },
                                data: ['考试人数', '获证人数']
                            }
                        ],
                        yAxis: [
                            {
                                type: 'value',
                                name: '考试人数',
                                axisLabel: { //y轴的坐标文字
                                    show: true,
                                    textStyle: {
                                        color: '#888' //文字的颜色
                                    },

                                },
                                axisLine: {
                                    show: false,
                                    lineStyle: {
                                        color: '#888'
                                    }
                                },
                                axisTick: {
                                    show: false,
                                }
                            },
                        ],
                        series: [
                            {
                                data: [
                                    {
                                        value: this.first_data.exam_num,
                                        itemStyle: {
                                            color: '#2C95FF'
                                        }
                                    },
                                    {
                                        value: this.first_data.certificate_num,
                                        itemStyle: {
                                            color: '#F23B2F'
                                        }
                                    }
                                ],
                                type: 'bar',
                                barWidth: 30,
                                itemStyle: {
                                    normal: {
                                        label: {
                                            show: true,      //开启显示
                                            position: 'top', //在上方显示
                                            textStyle: {     //数值样式
                                                color: '#888888',
                                                fontSize: 14
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                )
            },
            //技能分析
            setSkillAnalysis() {
                this.skillAnalysis.setOption(
                    {
                        // 图表的位置
                        grid: {
                            position: 'center',
                        },
                        tooltip: {
                            trigger:'item',
                            //雷达图的tooltip不会超出div，也可以设置position属性，position定位的tooltip 不会随着鼠标移动而位置变化，不友好
                            confine: true,
                            enterable: true, //鼠标是否可以移动到tooltip区域内
                            borderWidth: "1", //边框宽度设置1
                            borderColor: "#888",
                            backgroundColor: '#fff',
                            textStyle: {
                                color: "#666666" //设置文字颜色
                            },
                        },
                        radar: {
                            shape: 'circle',
                            splitNumber: 3, // 雷达图圈数设置
                            name: {
                                textStyle: {
                                    color: '#444444',
                                    fontSize: 14,
                                },
                            },
                            // 设置雷达图中间射线的颜色
                            axisLine: {
                                lineStyle: {
                                    color: 'rgba(131,141,158,.1)',
                                },
                            },
                            indicator: this.skill_children_list,
                            //雷达图背景的颜色，在这儿随便设置了一个颜色，完全不透明度为0，就实现了透明背景
                            splitArea: {
                                show: false,
                                areaStyle: {
                                    color: 'rgba(255,0,0,0)', // 图表背景的颜色
                                },
                            },
                            splitLine: {
                                show: true,
                                lineStyle: {
                                    width: 1,
                                    color: 'rgba(131,141,158,.1)', // 设置网格的颜色
                                },
                            },
                        },
                        series: [{
                            type: 'radar', //表示是雷达图
                            symbol: 'circle', // 拐点的样式，还可以取值'rect','angle'等
                            smooth: true,
                            symbolSize: 0, // 拐点的大小

                            areaStyle: {
                                normal: {
                                    width: 1,
                                    opacity: 0,
                                },
                            },
                            data: [
                                {
                                    value: this.skillRate,
                                    name: '各项技能占比：',
                                    // 设置区域边框和区域的颜色
                                    itemStyle: {
                                        normal: {
                                            color: new echarts.graphic.LinearGradient(
                                                0, 0, 0, 1,
                                                [
                                                    {offset: 0, color: '#2DC079'},
                                                    {offset: 0.5, color: '#BAD80B'},
                                                    {offset: 1, color: '#02C9D0'}
                                                ]
                                            ),
                                            lineStyle: {
                                                color: 'rgba(255,0,0,0)',
                                            },
                                        },
                                    },
                                    //在拐点处显示数值
                                    label: {
                                        normal: {
                                            show: true,
                                            formatter: (params) => {
                                                return params.value
                                            },
                                        },
                                    },
                                },
                            ],
                        }],
                    }
                )
            },
            //考试次数
            setExamNum() {
                let date = [];
                let data = [];
                this.fifth_data.curve_data.forEach(item => {
                    data.push(item.num);
                    date.push(item.time);
                })
                this.examNum.setOption(
                    {
                        tooltip: {
                            trigger: 'axis',
                            borderWidth: "1", //边框宽度设置1
                            borderColor: "#888",
                            backgroundColor: '#fff',
                            textStyle: {
                                color: "#666666" //设置文字颜色
                            },
                        },
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data: date,
                            show: false,
                            splitLine: {show: false}, //去除网格线
                        },
                        yAxis: {
                            type: 'value',
                            boundaryGap: [0, '100%'],
                            show: false,
                            splitLine: {show: false}, //去除网格线
                        },
                        series: [
                            {
                                name: '次数',
                                type: 'line',
                                symbol: 'none',
                                itemStyle: {
                                    color: '#F5AF23'
                                },
                                areaStyle: {
                                    color: '#F5AF23'
                                },
                                data: data
                            }
                        ]
                    }
                )
            },
            //训练人数
            setTrainPeopleNum() {
                let date = [];
                let data = [];
                this.sixth_data.curve_data.forEach(item => {
                    data.push(item.num);
                    date.push(item.time);
                })
                this.trainPeopleNum.setOption(
                    {
                        color: ['#2C95FF'],
                        tooltip: {
                            trigger: 'axis',
                            position: function (pt) {
                                return [pt[0], '10%'];
                            }
                        },
                        xAxis: {
                            type: 'category',
                            data: date,
                            show: false,
                            splitLine: {show: false}, //去除网格线
                        },
                        yAxis: {
                            type: 'value',
                            show: false,
                            splitLine: {show: false}, //去除网格线
                        },
                        series: [{
                            name: '人数',
                            data: data,
                            type: 'bar',
                            barWidth: 20,
                        }]
                    }
                )
            },
            //训练次数
            setTrainNum() {
                let date = [];
                let data = [];
                this.seventh_data.curve_data.forEach(item => {
                    data.push(item.num);
                    date.push(item.time);
                })
                this.trainNum.setOption(
                    {
                        color: ['#62D69F'],
                        tooltip: {
                            trigger: 'axis',
                            position: function (pt) {
                                return [pt[0], '10%'];
                            }
                        },
                        xAxis: {
                            type: 'category',
                            data: date,
                            show: false,
                            splitLine: {show: false}, //去除网格线
                        },
                        yAxis: {
                            type: 'value',
                            show: false,
                            splitLine: {show: false}, //去除网格线
                        },
                        series: [{
                            name: '次数',
                            data: data,
                            type: 'bar',
                            barWidth: 20,
                        }]
                    }
                )
            },
            //模拟考试图表
            setMockExam() {
                /**
                 * 折现图示例：https://www.makeapie.com/editor.html?c=x4SFfqL-2R
                 * */
                let pass_rate = [];
                let exam_num = [];
                let data_name = [];
                this.mocks_data.list.forEach(item => {
                    exam_num.push(item.exam_num);
                    pass_rate.push(item.pass_rate);
                    data_name.push(item.exam_name);
                })
                let join_people_number = [].concat(exam_num);
                join_people_number.sort(function (a, b) {
                    return -(a - b);
                })
                let max_join_number = parseInt(join_people_number[0]) + 10;
                // let data_name = [];
                // for (let i = 0; i < exam_num.length; i++) {
                //     let times_name = NumberToChinese(i+1);
                //     data_name.push(`模拟考试${times_name}`);
                // }
                const colorList = ["#2C95FF", '#F23B2F', '#fe9a8b', '#F56948', '#9E87FF'];
                this.mockExam.setOption(
                    {
                        backgroundColor: '#fff',
                        title: {},
                        legend: {
                            icon: 'circle',
                            bottom: '1%',
                            right: 'center',
                            itemWidth: 6,
                            itemGap: 20,
                            textStyle: {
                                color: '#556677'
                            }
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                label: {
                                    show: true,
                                    backgroundColor: '#fff',
                                    color: '#556677',
                                    borderColor: 'rgba(0,0,0,0)',
                                    shadowColor: 'rgba(0,0,0,0)',
                                    shadowOffsetY: 0
                                },
                                lineStyle: {
                                    width: 0
                                }
                            },
                            backgroundColor: '#fff',
                            textStyle: {
                                color: '#5c6c7c'
                            },
                            padding: [10, 10],
                            extraCssText: 'box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)'
                        },
                        grid: {
                            top: '10%',
                            left: '5%',
                            right: '5%'
                        },
                        xAxis: [{
                            type: 'category',
                            data: data_name,
                            axisLine: {
                                lineStyle: {
                                    color: '#DCE2E8'
                                }
                            },
                            axisTick: {
                                show: false
                            },
                            axisLabel: {
                                interval: 0,
                                textStyle: {
                                    color: '#556677'
                                },
                                // 默认x轴字体大小
                                fontSize: 12,
                                // margin:文字到x轴的距离
                                margin: 15
                            },
                            axisPointer: {
                                label: {
                                    // padding: [11, 5, 7],
                                    padding: [0, 0, 10, 0],
                                    /*
                        除了padding[0]建议必须是0之外，其他三项可随意设置

                        和CSSpadding相同，[上，右，下，左]

                        如果需要下边线超出文字，设左右padding即可，注：左右padding最好相同

                        padding[2]的10:

                        10 = 文字距下边线的距离 + 下边线的宽度

                        如：UI图中文字距下边线距离为7 下边线宽度为2

                        则padding: [0, 0, 9, 0]

                                    */
                                    // 这里的margin和axisLabel的margin要一致!
                                    margin: 15,
                                    // 移入时的字体大小
                                    fontSize: 12,
                                    backgroundColor: {
                                        type: 'linear',
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        colorStops: [{
                                            offset: 0,
                                            color: '#fff' // 0% 处的颜色
                                        }, {
                                            // offset: 0.9,
                                            offset: 0.86,
                                            /*
                    0.86 = （文字 + 文字距下边线的距离）/（文字 + 文字距下边线的距离 + 下边线的宽度）

                                            */
                                            color: '#fff' // 0% 处的颜色
                                        }, {
                                            offset: 0.86,
                                            color: '#33c0cd' // 0% 处的颜色
                                        }, {
                                            offset: 1,
                                            color: '#33c0cd' // 100% 处的颜色
                                        }],
                                        global: false // 缺省为 false
                                    }
                                }
                            },
                            boundaryGap: true
                        }],
                        yAxis: [{
                            name: '考试人数(人)',
                            nameTextStyle: {
                                color: '#888888',
                                fontWeight: 'bold'
                            },
                            max: max_join_number,
                            type: 'value',
                            axisTick: {
                                show: false
                            },
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: '#DCE2E8'
                                }
                            },
                            axisLabel: {
                                textStyle: {
                                    color: '#556677'
                                }
                            },
                            splitLine: {
                                show: true
                            }
                        }, {
                            name: '合格率(%)',
                            nameTextStyle: {
                                color: '#888888',
                                fontWeight: 'bold'
                            },
                            type: 'value',
                            position: 'right',
                            max: 100,
                            axisTick: {
                                show: false
                            },
                            axisLabel: {
                                textStyle: {
                                    color: '#556677'
                                },
                                formatter: '{value}'
                            },
                            axisLine: {
                                show: true,
                                lineStyle: {
                                    color: '#DCE2E8'
                                }
                            },
                            splitLine: {
                                show: false
                            }
                        }],
                        series: [{
                            name: '考试人数',
                            type: 'line',
                            data: exam_num,
                            symbolSize: 1,
                            symbol: 'circle',
                            smooth: true,
                            yAxisIndex: 0,
                            showSymbol: false,
                            lineStyle: {
                                width: 5,
                                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 0,
                                    color: '#9effff'
                                },
                                    {
                                        offset: 1,
                                        color: '#9E87FF'
                                    }
                                ]),
                                shadowColor: 'rgba(158,135,255, 0.3)',
                                shadowBlur: 10,
                                shadowOffsetY: 20
                            },
                            itemStyle: {
                                normal: {
                                    color: colorList[0],
                                    borderColor: colorList[0]
                                }
                            }
                        },
                            {
                                name: '合格率',
                                type: 'line',
                                data: pass_rate,
                                symbolSize: 1,
                                yAxisIndex: 1,
                                symbol: 'circle',
                                smooth: true,
                                showSymbol: false,
                                lineStyle: {
                                    width: 5,
                                    color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                        offset: 0,
                                        color: '#fe9a'
                                    },
                                        {
                                            offset: 1,
                                            color: '#fe9a8b'
                                        }
                                    ]),
                                    shadowColor: 'rgba(254,154,139, 0.3)',
                                    shadowBlur: 10,
                                    shadowOffsetY: 20
                                },
                                itemStyle: {
                                    normal: {
                                        color: colorList[1],
                                        borderColor: colorList[1]
                                    }
                                }
                            }
                        ]
                    }
                )
            },
            //查看更多学生数据
            viewMore(class_id) {
                if (this.role === '2') {
                    this.$router.push({
                        path: '/school/data/detail',
                        query: {
                            c_id: class_id
                        }
                    });
                } else {
                    this.$router.push({
                        path: '/dataCenter/detail',
                        query: {
                            c_id: class_id
                        }
                    });
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .data-center {
        position: relative;
        top: -20px;
        bottom: 0;
        width: 100%;
        height: calc(100% + 20px);
        background-color: #F7F8FC;

        ::v-deep > .el-scrollbar__wrap {
            overflow-x: hidden;
        }
    }

    .data-content {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        width: 100%;
        height: 100%;
        background-color: #F7F8FC;
        margin: 0 auto;
        box-sizing: border-box;

        .filter-box {
            background: #ffffff;
            height: 80px;
            display: flex;
            align-items: center;

            .filter-item {
                margin-left: 32px;
                display: flex;
                align-items: center;

                .icon-box {
                    width: 40px;
                    height: 39px;
                    background: #E2F9FB;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    i {
                        font-size: 22px;
                    }
                }

                .item-name {
                    margin-left: 12px;
                    font-size: 16px;
                }

                &:nth-of-type(2) {
                    margin-left: 54px;
                }
            }
        }

        .data-select {
            width: 200px;
            margin-left: 15px;
        }

        .data-item {
            display: flex;
            flex-direction: column;
            margin-bottom: 30px;

            &:nth-of-type(2) {
                margin-top: 22px;
            }

            .title {
                position: relative;
                height: 50px;
                line-height: 50px;

                i {
                    color: #F23B2F;
                    font-size: 30px;
                    margin-right: 10px;
                }

                .text {
                    position: absolute;
                    display: inline-block;
                    width: 218px;
                    height: 50px;
                    line-height: 50px;
                    font-size: 20px;
                    color: #333;
                    font-weight: 500;
                }
            }

            .charts-top {
                display: flex;
                justify-content: space-between;
                margin: 20px 20px 0;
                position: relative;

                .left-title {
                    font-size: 16px;
                }

                .right-title {
                    font-size: 16px;
                    border-left: 1px solid #333333;
                    margin-left: 10px;
                    padding-left: 10px;
                    color: #2C95FF;
                }

                &:after {
                    position: absolute;
                    content: '';
                    bottom: -18px;
                    width: 100%;
                    height: 1px;
                    background: #EEEEEE;
                }

                .right-box {
                    display: flex;

                    .right-item {
                        display: flex;
                        align-items: center;

                        &:last-child {
                            margin-left: 20px;
                        }

                        .item-icon {
                            width: 14px;
                            height: 14px;
                            border-radius: 2px;
                            margin-right: 9px;

                            &.green {
                                background: #2DC079;
                            }

                            &.yellow {
                                background: #F5AF23;
                            }

                            &.cyan {
                                background: #BAD80B;
                            }
                        }

                        .item-name {
                            color: #666666;
                        }
                    }

                    .data-select {
                        height: 30px;

                        ::v-deep .el-input--suffix {
                            height: 30px;

                            .el-input__inner {
                                height: 30px;
                            }

                            .el-input__suffix {
                                display: flex;
                                align-items: center;
                            }
                        }
                    }
                }
            }

            .data-body {
                margin-top: 22px;

                .box {
                    display: flex;

                    .box-item {
                        background: #ffffff;
                        margin-left: 25px;

                        &:first-child {
                            margin-left: 0;
                            min-width: calc((100% - 406px) /2 - 20px);
                        }
                        &:nth-child(2) {
                            min-width: 356px;
                        }
                        &:nth-child(3) {
                            min-width: calc((100% - 406px) /2 + 20px);
                        }
                    }

                    .left {
                        display: flex;
                        flex: 1;
                        align-items: center;
                        width: 1%;
                        margin-right: 20px;

                        .exam-num {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 50%;
                            height: 100%;
                            background: #ffffff;
                            box-shadow: 0 0 10px 0 rgba(14, 168, 94, 0.1);
                            border-radius: 6px;
                            margin-right: 20px;
                            position: relative;

                            &:after {
                                position: absolute;
                                content: '';
                                height: 5px;
                                width: 100%;
                                background: #2C95FF;
                                bottom: 0;
                            }

                            .icon {
                                width: 116px;
                                height: 116px;
                                line-height: 116px;
                                background: #eee;
                                border-radius: 50%;
                                text-align: center;
                                margin-right: 40px;

                                i {
                                    font-size: 60px;
                                    color: #2C95FF;
                                }
                            }

                            .num-show {
                                display: flex;
                                flex-direction: column;

                                .text {
                                    font-size: 18px;
                                    font-weight: 400;
                                    color: #333333;
                                }

                                .num {
                                    font-size: 48px;
                                    font-weight: bold;
                                    color: #2C95FF;
                                    font-family: Source Han Sans CN;
                                }
                            }
                        }

                        .certified-num {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 50%;
                            height: 100%;
                            background: #ffffff;
                            box-shadow: 0 0 10px 0 rgba(14, 168, 94, 0.1);
                            border-radius: 6px;
                            margin-right: 20px;
                            position: relative;

                            &:after {
                                position: absolute;
                                content: '';
                                height: 5px;
                                width: 100%;
                                background: #F23B2F;
                                bottom: 0;
                            }

                            .icon {
                                width: 116px;
                                height: 116px;
                                line-height: 116px;
                                background: #eee;
                                border-radius: 50%;
                                text-align: center;
                                margin-right: 40px;

                                i {
                                    font-size: 60px;
                                    color: #F23B2F;
                                }
                            }

                            .num-show {
                                display: flex;
                                flex-direction: column;

                                .text {
                                    font-size: 18px;
                                    font-weight: 400;
                                    color: #333333;
                                }

                                .num {
                                    font-size: 48px;
                                    font-weight: bold;
                                    color: #F23B2F;
                                    font-family: Source Han Sans CN;
                                }
                            }
                        }
                    }

                    .right {
                        position: relative;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 452px;
                        height: 281px;
                        background-color: #fff;
                        box-shadow: 0 0 10px 0 rgba(14, 168, 94, 0.1);
                        border-radius: 6px;

                        .pass-rate {
                            display: inline-block;
                            position: absolute;
                            left: 198px;
                            top: 157px;
                            font-size: 18px;
                            color: #333;
                        }
                    }
                }

                .bottom-box {
                    display: flex;
                    margin-top: 23px;

                    .box-item {
                        background: #ffffff;
                        width: 25%;
                        margin-left: 19px;
                        border-radius: 6px;
                        box-shadow: 0px 0px 10px 0px rgba(14, 168, 94, 0.1);

                        &:first-child {
                            margin-left: 0;
                        }

                        .item-content {
                            padding: 20px;

                            .top-content {
                                .top-title {
                                    color: #666666;
                                }

                                .top-num {
                                    margin-top: 20px;
                                    font-size: 36px;
                                    color: #000000;
                                }
                            }

                            .middle-content {
                                position: relative;
                                margin-top: 20px;
                                height: 40px;
                                display: flex;
                                align-items: center;

                                &:after {
                                    content: '';
                                    position: absolute;
                                    height: 1px;
                                    width: 100%;
                                    bottom: -24px;
                                    background: #EEEEEE;
                                }
                            }

                            .first-title {
                                margin-right: 9px;
                            }

                            i {
                                margin-right: 9px;
                                font-size: 18px;
                            }

                            .middle-left {
                                i {
                                    color: #2DC079;
                                }
                            }

                            .middle-right {
                                margin-left: 70px;

                                i {
                                    color: #FF5500;
                                }
                            }

                            .bottom-content {
                                margin-top: 43px;
                                display: flex;
                                align-items: center;

                                .bottom-right {
                                    margin-left: 20px;
                                }
                            }
                        }
                    }
                }
            }
        }

        .class-item {
            display: flex;
            flex-direction: column;
            background: #FFFFFF;
            box-shadow: 0 0 10px 0 rgba(14, 168, 94, 0.1);
            border-radius: 6px;
            margin-top: 20px;
            padding: 40px 30px 20px 20px;
            box-sizing: border-box;

            .class-name {
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
            }

            .class-top {
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #2C95FF;
                margin-top: 40px;
            }

            .class-table {
                margin-top: 10px;

                .table-title {
                    height: 51px;
                    line-height: 51px;
                    background: #F6F6F6;
                    padding: 0 70px;
                }

                .title-item {
                    display: inline-block;
                    font-size: 14px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    color: #333;
                    text-align: center;
                    width: 15%;

                    &:nth-child(1) {
                        width: 40%;
                        text-align: left;
                    }
                }

                .table-body {
                    display: flex;
                    flex-direction: column;

                    .body-item {
                        display: flex;
                        align-items: center;
                        height: 90px;
                        padding: 0 70px;
                        border-bottom: 1px solid #EEEEEE;

                        .title-item {
                            color: #333;
                            font-weight: 400;
                        }
                        .pass-i {
                            color: #2DC079;
                            font-size: 30px;
                        }
                        .no-pass-i {
                            color: #FF0000;
                            font-size: 30px;
                        }

                        .student-name {
                            display: flex;
                            align-items: center;

                            img {
                                width: 42px;
                                height: 42px;
                                border-radius: 50%;
                                margin-right: 20px;
                            }
                        }
                    }
                }
            }

            .more {
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #F23B2F;
                margin-top: 27px;
                cursor: pointer;

                i {
                    font-size: 20px;
                }
            }
        }
    }
    .small-rate {
        ::v-deep .el-progress-bar__outer {
            border-radius: 0;
            .el-progress-bar__inner {
                border-radius: 0;
                .el-progress-bar__innerText {
                    display: none;
                }
            }
        }
    }
    .lin-icon {
        width: 100%;
        height: 10px;
        margin-left: 79%;
        .top-icon {
            display: inline-block;
            height: 10px;
            width: 3px;
            background-color: #18C1FF;
        }
    }
    .charts-box {
        position: relative;
        margin-top: 17px;
        flex: 1;
        height: 1%;
        display: flex;
        justify-content: center;
        align-items: center;
        .pass-rate {
            display: inline-block;
            position: absolute;
            left: 150px;
            top: 240px;
            font-size: 18px;
            color: #333;
        }
    }
    ::v-deep .el-progress__text {
        color: #2C95FF;
        font-weight: 500;
    }
    .is-school-data {
        margin-top: 20px;
    }
    .no-data {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }
    .is-no-data {
        display: none;
    }
</style>